import loadable from '@loadable/component';

export const ResumeDatabaseBannerLoadable = loadable(
  () => import('./ResumeDatabaseBanner'),
  { resolveComponent: (module) => module.ResumeDatabaseBanner },
);
